module.exports = __webpack_public_path__ + "img/selected2-min.7a78f5f5.png";